import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { devLog } from '../../lib/dev-logger';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase automatically handles the session
    // SupabaseAuthContext's onAuthStateChange is triggered
    devLog.info('Processing OAuth callback...');

    // Short delay then redirect to main page
    const timer = setTimeout(() => {
      // Check returnUrl parameter
      const urlParams = new URLSearchParams(window.location.search);
      const returnUrl = urlParams.get('returnUrl') || '/';

      devLog.info('OAuth login complete, redirecting to:', returnUrl);
      navigate(returnUrl, { replace: true });
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
      <div className="text-center">
        {/* Loading Spinner */}
        <div className="inline-block w-16 h-16 border-4 border-forest-400 border-t-transparent rounded-full animate-spin mb-4"></div>

        <h2 className="text-2xl font-display font-bold text-neutral-900 mb-2">Signing you in...</h2>
        <p className="text-neutral-600">Please wait a moment.</p>
      </div>
    </div>
  );
};

export default AuthCallback;
